import { render, staticRenderFns } from "./ExtraFieldsSettings.vue?vue&type=template&id=04103ca8&"
import script from "./ExtraFieldsSettings.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ExtraFieldsSettings.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports